<template>
  <div v-if="myAllProduct && myAllProduct.length > 0" class="carousel-wrapper">
    <h3 class="font-weight-bold text-secondary mb-4 px-3">สินค้าอื่นๆ</h3>
    <hr class="mt-0" />
    <div
      ref="carouselScroll"
      class="carousel-scroll"
      :class="{ 'is-dragging': isDragging }"
      @scroll="onCarouselScroll"
      @pointerdown="onDragStart"
      @pointermove="onDragMove"
      @pointerup="onDragEnd"
      @pointercancel="onDragEnd"
      @click.capture="onCarouselClick"
    >
      <div
        v-for="(product, n) in myAllProduct.filter(d => !d.get('isSubProduct'))"
        :key="n"
        v-show="currentProduct != product.id"
        class="carousel-item-box"
      >
        <ProductItem :product="product"/>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: ['currentProduct'],
  data() {
    return {
      myAllProduct: "",
      isDragging: false,
      suppressClick: false,
    }
  },
  computed: {
    ...mapState(['allProduct'])
  },
  async mounted() {
    this.myAllProduct = _.sortBy(this.allProduct, (p) => {
      return p.viewerCounter
    }).reverse();
  },
  methods: {
    canScroll(el) {
      return el && el.scrollWidth > el.clientWidth + 2
    },
    onCarouselScroll() {
      // scroll sync placeholder if needed later
    },
    onDragStart(e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return
      if (e.target.closest('button, .btn')) return

      const el = this.$refs.carouselScroll
      if (!this.canScroll(el)) return

      e.preventDefault()
      this.isDragging = true
      this.dragPointerId = e.pointerId
      this.dragStartX = e.clientX
      this.dragStartScroll = el.scrollLeft
      this.didDrag = false
      el.setPointerCapture(e.pointerId)
    },
    onDragMove(e) {
      if (!this.isDragging || e.pointerId !== this.dragPointerId) return

      e.preventDefault()
      const el = this.$refs.carouselScroll
      const delta = e.clientX - this.dragStartX
      if (Math.abs(delta) > 3) this.didDrag = true
      el.scrollLeft = this.dragStartScroll - delta
    },
    onDragEnd(e) {
      if (!this.isDragging || e.pointerId !== this.dragPointerId) return

      const el = this.$refs.carouselScroll
      if (el.hasPointerCapture(e.pointerId)) {
        el.releasePointerCapture(e.pointerId)
      }
      if (this.didDrag) this.suppressClick = true
      this.isDragging = false
      this.dragPointerId = null
    },
    onCarouselClick(e) {
      if (!this.suppressClick) return
      e.preventDefault()
      e.stopPropagation()
      this.suppressClick = false
    },
  },
}
</script>
<style scoped>
.carousel-wrapper {
  padding-bottom: 24px;
}
.carousel-scroll {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 0 12px 32px;
  gap: 16px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: thin;
  scrollbar-color: var(--light) #ececee;
  cursor: pointer;
  touch-action: pan-x;
}
.carousel-scroll::-webkit-scrollbar {
  height: 8px;
}
.carousel-scroll::-webkit-scrollbar-track {
  background: #ececee;
  border-radius: 4px;
}
.carousel-scroll::-webkit-scrollbar-thumb {
  background: var(--light);
  border-radius: 4px;
}
.carousel-scroll.is-dragging {
  cursor: pointer;
  user-select: none;
  touch-action: none;
}
.carousel-scroll.is-dragging ::v-deep * {
  pointer-events: none;
}
.carousel-scroll ::v-deep img {
  -webkit-user-drag: none;
  user-select: none;
}
.carousel-item-box {
  flex: 0 0 280px;
  min-width: 280px;
  transition: transform 0.2s;
}
.carousel-item-box:hover {
  transform: translateY(-4px);
}
.carousel-scroll.is-dragging .carousel-item-box:hover {
  transform: none;
}
</style>
